import { connect } from 'react-redux';

import FilterSwitchBox from 'modules/portfolio/components/common/filter-switch-box';

const mapStateToProps = state => ({});

const FilterSwitchBoxContainer = connect(mapStateToProps)(FilterSwitchBox);

export default FilterSwitchBoxContainer;
